import { Link } from 'react-router';
import { Button } from '@/components/ui/Button';
import { HeroGift } from '@/components/HeroGift';
import { copy } from '@/lib/copy';

export function Landing() {
  return (
    <section className="flex-1 flex flex-col items-center justify-center px-6 py-20 text-center">
      <HeroGift className="mb-10 w-28 sm:w-32" />

      <h1 className="font-display text-5xl md:text-6xl font-semibold max-w-3xl mb-6">
        {copy.landing.headline}
      </h1>
      <p className="text-lg text-ink-muted max-w-xl mb-10">
        {copy.landing.subhead}
      </p>

      <div className="flex flex-col sm:flex-row gap-4">
        <Link to="/create">
          <Button size="lg">{copy.landing.primaryCta}</Button>
        </Link>
        <Link to="/how-it-works">
          <Button size="lg" variant="secondary">
            {copy.landing.secondaryCta}
          </Button>
        </Link>
      </div>
    </section>
  );
}
